import { createSlice } from "@reduxjs/toolkit";
import { role } from "../../common/general"

const authSlice = createSlice({
  name: "auth",
  initialState: {
    auth: {
      currentUser: null,
      isFetching: false,
      isLoggedIn: false,
      role: role.CUSTOMER,
      error: false,
    }
  },
  reducers: {
    login: (state) => {
      state.auth.isFetching = true;
      state.auth.error = false;
    },
    loginSuccess: (state, action) => {
      state.auth.isFetching = false;
      state.auth.currentUser = action.payload.info;
      state.auth.error = false;
      state.auth.isLoggedIn = true;
      state.auth.role = action.payload.role
    },
    loginFailed: (state) => {
      state.auth.isFetching = false;
      state.auth.isLoggedIn = false;
      state.auth.error = true;
    },
    register: (state) => {
      state.auth.isFetching = true;
      state.auth.error = false;
    },
    registerSuccess: (state, action) => {
      state.auth.isFetching = false;
      state.auth.error = false;
    },
    registerFailed: (state) => {
      state.auth.isFetching = false;
      state.auth.error = true;
    },
    forgotPassword: (state) => {
      state.auth.isFetching = true;
      state.auth.error = false;
    },
    forgotPasswordSuccess: (state) => {
      state.auth.isFetching = false;
      state.auth.error = false;
    },
    forgotPasswordFailed: (state) => {
      state.auth.isFetching = false;
      state.auth.error = true;
    },
    changeAvatar: (state) => {
      state.auth.isFetching = true;
      state.auth.error = false;
    },
    changeAvatarSuccess: (state, action) => {
      state.auth.isFetching = false;
      state.auth.currentUser.user.avatar = action.payload;
      state.auth.error = false;
    },
    changeAvatarFailed: (state) => {
      state.auth.isFetching = false;
      state.auth.error = true;
    },
    logout: (state) => {
      state.auth.isFetching = false;
      state.auth.currentUser = null;
      state.auth.error = false;
      state.auth.isLoggedIn = false;
      state.auth.role = role.CUSTOMER
    },
    getInfo: (state) => {
      state.auth.isFetching = true;
      state.auth.error = false;
    },
    getInfoSuccess: (state, action) => {
      state.auth.isFetching = false;
      state.auth.currentUser = action.payload.info;
      state.auth.error = false;
      state.auth.isLoggedIn = true;
      state.auth.role = action.payload.role
    },
    getInfoFailed: (state) => {
      state.auth.isFetching = false;
      state.auth.isLoggedIn = false;
      state.auth.error = true;
    },
    updateAccount: (state) => {
      state.auth.isFetching = true;
      state.auth.error = false;
    },
    updateAccountSuccess: (state, action) => {
      state.auth.isFetching = false;
      state.auth.currentUser = { ...state.auth.currentUser, ...action.payload.info };
      state.auth.error = false;
    },
    updateAccountFailed: (state) => {
      state.auth.isFetching = false;
      state.auth.error = true;
    },
    changePassword: (state) => {
      state.auth.isFetching = true;
      state.auth.error = false;
    },
    changePasswordSuccess: (state, action) => {
      state.auth.isFetching = false;
      state.auth.error = false;
    },
    changePasswordFailed: (state) => {
      state.auth.isFetching = false;
      state.auth.error = true;
    },
  },
});

export const authAction = authSlice.actions;
export default authSlice.reducer;
